import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import axios from 'axios'
import moment from 'moment-timezone'
import {
  Button,
  ButtonContainer,
  Row,
  Col,
  Spinner
} from 'camino-react'

import ListOfLinkedItemsModal from './ListOfLinkedItemsModal'

import { saveLocalStorageItem, loadLocalStorageItem } from 'Utilities/LocalStorage'
import Modal from 'Components/Modal'

class NoticesModal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      clients: [],
      showModal: true
    }
  }

  componentDidMount = () => {
    if (this.isModalHiddenForTwentyFourHours()) {
      this.fetchNoticesItems()
        .then((noticesItems) => {
          this.fetchClients(noticesItems)
            .then((clients) => {
              this.setState({
                clients,
                noticesItems
              })
            })
        })
    }
  }

  fetchNoticesItems = () => {
    const { itemType, itemId } = this.props
    return axios.get(`/api/associated_notices/${itemType}/${itemId}.json`, {})
      .then(({ data }) => data)
      // eslint-disable-next-line
      .catch(error => console.log(error))
  }

  fetchClients = (noticesItems) => {
    const clientNoticeItems = _.filter(noticesItems, { noticeable_type: 'Client' })
    const clientIds = _.map(clientNoticeItems, notice => notice.noticeable_id)

    if (_.isEmpty(clientIds)) {
      return Promise.resolve([])
    }
    return axios.get('/api/clients', {
      params: {
        client_ids: _.uniq(clientIds)
      }
    })
      .then(({ data }) => data)
  }

  hideModalForTwentyFourHours = () => {
    const { itemType, itemId } = this.props
    saveLocalStorageItem('noticesHiddenForTwentyFourHours', `${itemType}-${itemId}`, moment())
    this.setState({ showModal: false })
  }

  isModalHiddenForTwentyFourHours = () => {
    const { itemType, itemId } = this.props
    const localStorageTime = loadLocalStorageItem('noticesHiddenForTwentyFourHours', `${itemType}-${itemId}`)
    if (localStorageTime) {
      return moment(localStorageTime) < moment().subtract(1, 'days')
    }
    return true
  }

  render () {
    const {
      showModal,
      clients,
      noticesItems
    } = this.state
    const {
      itemType,
      ticketNotices,
      ticketProblemId,
      ticketProblemNotices,
      problemNotices,
      problemId
    } = this.props

    const noticeItemsByType = _.groupBy(noticesItems, 'noticeable_type')

    const loadingClient = !_.isEmpty(noticeItemsByType.clientNotices) && _.isEmpty(clients) ? 'Loading ...' : ''
    return (
      <div>
        {this.isModalHiddenForTwentyFourHours() && (
          <Modal showModal={showModal} title="Notices" removeModal={() => { this.setState({ showModal: false }) }}>
            {_.some(noticeItemsByType) ? (
              <div>
                <div>
                  <ListOfLinkedItemsModal
                    {...{
                      noticeItemsByType, clients, loadingClient, itemType
                    }}
                    ticketNotices={ticketNotices}
                    ticketProblemId={ticketProblemId}
                    ticketProblemNotices={ticketProblemNotices}
                    problemNotices={problemNotices}
                    problemId={problemId}
                  />
                </div>

                <ButtonContainer center spaced>
                  <Button
                    outline
                    onClick={this.hideModalForTwentyFourHours}
                  >
                    Hide for 24 hours
                  </Button>
                  <Button
                    onClick={() => { this.setState({ showModal: false }) }}
                  >
                    Confirm
                  </Button>
                </ButtonContainer>
              </div>
            ) : (
              <Row>
                <Col />
                <Col>
                  <Spinner fill />
                </Col>
                <Col />
              </Row>
            )
            }
          </Modal>
        )}
      </div>
    )
  }
}


NoticesModal.propTypes = {
  itemType: PropTypes.string.isRequired
}

NoticesModal.defaultProps = {
  problemId: null,
  ticketProblemId: null
}

export default NoticesModal
